<template>
    <c-tag
        :label            = "label"
        :background-color = "color"
        :active           = "active"
        class             = "quality-flag"
    />
</template>

<script>
import CTag from "@/modules/core/components/utils/CTag";
export default {
    name: "CImportQualityTag",

    components: {
        CTag
    },

    props: {
        count: {

        },
        color: {

        },
    },

    computed: {
        label () {
            if (!this.count) {
                return "";
            }

            return this.count.toString();
        },

        active () {
            if (!this.count) {
                return false;
            }

            return true;
        }
    }
}
</script>

<style scoped>

.quality-flag {
    margin-right: 2px;
}

</style>